export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/luckincard/pay-result' */ './PayResult'
  );
